import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SubHeader from './SubHeader';
import GeofencesTable from './GeofencesTable';
import './Geofence.css';

@inject('commonStore', 'translationsStore', 'filterStore', 'geofencesStore')
@observer
export default class Geofence extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    const { geofencesStore, commonStore } = this.props;
    commonStore.setLoading(true);
    setTimeout(() => {
      Promise.all([geofencesStore.load()]).then(() => {
        commonStore.setLoading(false);
      });
    }, 200);
  }

  componentDidMount = () => {};

  componentWillUnmount = () => {
    this.props.filterStore.reset();
  };

  render() {
    const { geofencesStore } = this.props;
    return (
      <div className={`GeoFenceDashboard ${this.props.commonStore.loading ? 'loading' : ''}`}>
        <SubHeader />
        {this.props.commonStore.loading === false && <GeofencesTable geofences={geofencesStore.filtered} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Geofence/Geofence.js